// get rid of "data:*/*;base64," in order to send pure base64 to the server
export const getBase64PreparedImage = (image: string) => image.split(',').pop();
